export default {
  // messages
  'assignServices.achLabelForWarning': 'one ACH transaction type',
  'assignServices.erdLabelForWarning': 'Electronic Reports',
  'assignServices.oneAccountFor': 'one account for ',
  'assignServices.oneReportFor': 'one report for ',
  'assignServices.accountsFor': 'account(s) for ',
  'assignServices.accountsForERDForWarning': 'account(s) for Electronic Reports',
  'assignServices.reportsForERDForWarning': ' and one report for Electronic Reports',
  'assignServices.statements': 'Statements',
  'assignServices.selectAccountServicesWarning':
    'Please select at least one account for <%= accountPermissions %>.',
  'assignServices.selectServicesWarning': 'Please select at least <%= items %>.',
  'assignServices.selectServiceWarning': 'Please select at least one Service component.',

  // labels
  'assignServices.accountHistory': 'Bank Account Info Reporting',
  'assignServices.accountPermissions': 'Account Level Permissions.',
  'assignServices.accountType.from': 'From',
  'assignServices.accountType.fromTo': 'From/To',
  'assignServices.accountType.to': 'To',
  'assignServices.ach': 'ACH',
  'assignServices.achPositivePay': 'ACH Positive Pay',
  'assignServices.paymentRules': 'Payment Rules',
  'assignServices.exceptionDecisions': 'Exception Decisions',
  'assignServices.achPermissions': 'ACH Level Permissions.',
  'assignServices.achSender': 'ACH Sender ID',
  'assignServices.achTotals': 'ACH Totals',
  'assignServices.ACHReversal': 'ACH Reversal',
  'assignServices.administration': 'Administration',
  'assignServices.applySelectionTo': 'Apply selection to',
  'assignServices.approval': 'Approval',
  'assignServices.approvePayee': 'Approve Payee',
  'assignServices.approvePayment': 'Approve Payment',
  'assignServices.auditReport': 'User Activity Audit Report',
  'assignServices.bookApproval': 'Approval',
  'assignServices.bookTransferInput': 'Input',
  'assignServices.bookTransferImport': 'Import',
  'assignServices.bookTransfers': 'Transfers',
  'assignServices.brSameDayRpt': 'BR - Same Day Rpt.',
  'assignServices.cashPositionWorksheet': 'Cash Position Worksheet',
  'assignServices.checkPositivePay': 'Check Positive Pay Exceptions',
  'assignServices.collectPayments': 'Collect Payments',
  'assignServices.coreServices': 'Core Services',
  'assignServices.defineImportMap': 'Define Import Map',
  'assignServices.dynamicLinks': 'Dynamic Links',
  'assignServices.draw': 'Draw',
  'assignServices.directConnect': 'DirectConnect',
  'assignServices.erd': 'Electronic Report Delivery',
  'assignServices.ERDReport': 'ERD Report',
  'assignServices.statementPermissions': 'Statement Permissions',
  'assignServices.erdReportPermissions': 'ERD Report Permissions',
  'assignServices.exceptionDecision': 'Exception Decision',
  'assignServices.expeditedPayments': 'Expedited Payments',
  'assignServices.freeFormAllowed': 'Free-Form Payments are allowed',
  'assignServices.freeFormInitiation': 'Free-Form Initiation',
  'assignServices.import': 'Import',
  'assignServices.importIssueFile': 'Import Issue File',
  'assignServices.initiatePayment': 'Initiate Payment',
  'assignServices.input': 'Input',
  'assignServices.inputManualIssue': 'Input Manual Issue/Void',
  'assignServices.incomingWireDetail': 'Incoming Wire Detail',
  'assignServices.issueManagement': 'Issue Management',
  'assignServices.loan': 'Loan',
  'assignServices.loanAccountInfoReporting': 'Loan Account Info Reporting',
  'assignServices.loans': 'Loans',
  'assignServices.makeLoanDraws': 'Make Loan Draws',
  'assignServices.managementReporting': 'Management Reporting',
  'assignServices.managePayee': 'Manage Payee',
  'assignServices.mobile': 'Mobile',
  'assignServices.mobileAccess': 'Mobile Access',
  'assignServices.mobileCheckDeposit': 'Mobile Check Deposit',
  'assignServices.moneyTransfers': 'Wire Transfers',
  'assignServices.noAvailableAch': 'No ACH Transaction Types available.',
  'assignServices.onlineStatements': 'Statements',
  'assignServices.others': 'Others',
  'assignServices.passThru': 'Pass-Thru',
  'assignServices.passThruActivityViewOnly': 'Pass-Thru Activity View Only',
  'assignServices.passThruApproval': 'Pass-Thru Approval',
  'assignServices.payeeDirectory': 'Payee Directory',
  'assignServices.payment': 'Payment',
  'assignServices.paymentApproval': 'Payment Approval',
  'assignServices.paymentRuleApproval': 'Payment Rule Approval',
  'assignServices.paymentReport': 'Payment Report',
  'assignServices.paymentReversal': 'ACH Reversals',
  'assignServices.payments': 'Payments',
  'assignServices.paymentsServices': 'Payments Services',
  'assignServices.paymentTemplateViewOnly': 'Payment & Template View Only',
  'assignServices.permissions': 'Permissions',
  'assignServices.permissionsCopiedFrom': 'Permissions Copied From',
  'assignServices.permissionsName': 'Permissions Name',
  'assignServices.reportName': 'Report Name',
  'assignServices.statementName': 'Statement Name',
  'assignServices.reportPermissions': 'Report/Account Level Permissions.',
  'assignServices.sameDayReport': 'Same Day Report',
  'assignServices.sbPaymentAdmin': 'SB Payment Admin',
  'assignServices.sendExpeditedPayments': 'Send Expedited Payments',
  'assignServices.sendLoanPayments': 'Send Loan Payments',
  'assignServices.sendRegularPayments': 'Send Regular Payments',
  'assignServices.sendTaxPayments': 'Send Tax Payments',
  'assignServices.simplifiedPayments': 'Simplified Payments',
  'assignServices.smallBusinessACH': 'Small Business ACH',
  'assignServices.sso': 'Outbound SSO',
  'assignServices.stopPayments': 'Stop Payments',
  'assignServices.stopReports': 'Stop Reports',
  'assignServices.templateApproval': 'Template Approval',
  'assignServices.templateInitiation': 'Template Initiation',
  'assignServices.templateManagement': 'Template Management',
  'assignServices.title': 'Assign Services',
  'assignServices.transactionTypes': 'Transaction Types',
  'assignServices.transferAbility': 'Transfer Ability',
  'assignServices.userAdministration': 'User Administration',
  'assignServices.userMaintenance': 'User Maintenance',
  'assignServices.viewOnly': 'View Only',
  'assignServices.viewOnlyCollectPayments': 'View Only Collect Payments',
  'assignServices.viewOnlyExpeditedPayments': 'View Only Expedited Payments',
  'assignServices.viewOnlyLoanPayments': 'View Only Loan Payments',
  'assignServices.viewOnlyRegularPayments': 'View Only Regular Payments',
  'assignServices.viewOnlyTaxPayments': 'View Only Tax Payments',
  'assignServices.wireImport': 'Import',
  'assignServices.sendEmployeePayments': 'Send Employee Payments',
  'assignServices.sendEmployeeViewOnly': 'View Only Employee Payments',

  // tabs
  'assignServices.tab.accountLevelPermissions': 'Account Level Permissions',
  'assignServices.tab.ACHPermissions': 'ACH Permissions',
  'assignServices.tab.reportPermissions': 'Report Permissions',

  // screen reader
  'assignServices.checkbox.selectAllServices': 'Select all services',
  'assignServices.checkbox.selectAllPermissions': 'Select all permissions',
  'assignServices.checkbox.selectAllServiceBlock': 'Select all <%= services %>',
  'assignServices.checkbox.achPermissions.selectAll': 'Select all ACH permissions',
  'assignServices.checkbox.achPermissions.selectAllPermissions':
    'Select all transaction types for  <%= sender %>',
  'assignServices.checkbox.entitleAccountsTable.selectAllAccounts':
    'Select all accounts for <%= type %>',
  'assignServices.checkbox.reportPermissions.selectForAllAccounts':
    'Select all accounts for Associated Report type',
  'assignServices.checkbox.entitleAccountsTable.selectAllPermissions':
    'Select all permissions for <%= account %>',
  'assignServices.checkbox.entitleAccountsTable.selectitem':
    'Enable <%= permission %> for <%= account %>'
};
